import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { AvatarGroup } from 'primereact/avatargroup';
import { Avatar } from 'primereact/avatar';
import { Tooltip } from 'primereact/tooltip';
import { Dialog } from 'primereact/dialog';
import { ToggleButton } from 'primereact/togglebutton';
import { ColorPicker } from 'primereact/colorpicker';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import jwt_decode from 'jwt-decode';
import gisservice from '@services/gisservice.service';
import planningService from '@services/planning.service';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';
import { Tag } from 'primereact/tag';
import toast from 'react-hot-toast';
import strftime from 'strftime';
import Joi from 'joi';

const Legends = () => {
  const [loading, setLoading] = useState(false);
  const token = jwt_decode(localStorage.getItem('plano-jwt'));
  const userName =
    token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
  const technology = ['2G', '3G', '4G', 'TDD BH', '4G Cell Level'];
  const [selectedTechnology, setSlectedTechnology] = useState('');
  const [legends, setLegends] = useState([]);
  const [allKPIs, setAllKPIs] = useState([]);
  const [relatedKpis, setRelatedKpis] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [dialogVisible, setDialogVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [CreateRelatedKPIs, SetCreateRelatedKPIs] = useState([]);
  const [isSpecialKPI, setIsSpecialKPI] = useState(true);
  const menuCreate = useRef(null);
  const special_KPIs = [
    'LMBB Configuration',
    'Overshoot Flag',
    'Coverage Flag',
  ];
  const OvershootValues = ['0', 'Overshoot'];
  const CoverageValues = ['0', 'UB'];
  const LMBB_Configuration = [
    'LMBB_FULL',
    'LMBB_FULL_WITH_L9',
    'LMBB_FULL_WITH_ONE_L23',
    'LMBB_FULL_WITH_THREE_L23',
    'LMBB_FULL_WITH_TWO_L23',
    'LMBB_FULL_WITH_TWO_L23_WITH_L9',
    'LMBB_NOT_FULL',
    'LMBB_NOT_FULL_WITH_L9',
    'LMBB_NOT_FULL_WITH_TWO_L23',
    'ONLY_L9',
    'ONLY_TWO_L23',
  ];
  const publicMap = {
    'Public': true,
    'Private': false
  }
  const rangesTemplate = (rowData) => {
    return (
      <>
        <AvatarGroup maxItems={rowData.ranges.length}>
          {rowData.ranges.map((range) => (
            <>
              <Tooltip target={`.rangesAvatar${range._id}`} />
              <Avatar
                className={`rangesAvatar${range._id}`}
                style={{ backgroundColor: range.color }}
                shape="square"
                size="small"
                data-pr-tooltip={
                  special_KPIs.includes(rowData.name)
                    ? `${range.category_name}`
                    : `${range.min}-${range.max}`
                }
              ></Avatar>
            </>
          ))}
        </AvatarGroup>
      </>
    );
  };

  async function handleDelete() {
    setLoading(true);
    const id = selectedRow._id;
    const Creator = selectedRow.Creator;
    if (Creator !== userName) {
      toast.error('Only Legend creator has the right to delete it.');
    } else {
      try {
        await gisservice.Delete('/legend', { id, Creator });
        fetcher();
        setDeleteVisible(false);
      } catch (err) {
        console.log(err);
      }
    }
  }

  const deleteTemplate = (rowData) => {
    return (
      <Button
        icon="pi pi-times"
        rounded
        text
        severity="danger"
        aria-label="Cancel"
        onClick={() => {
          setDeleteVisible(true);
          setSelectedRow(rowData);
        }}
      />
    );
  };

  const editTemplate = (rowData) => {
    return (
      <Button
        icon="pi pi-file-edit"
        rounded
        text
        severity="help"
        onClick={() => {
          setEditMode(true);
          if (special_KPIs.includes(rowData.name)) {
            setSelectedRow({
              ...rowData,
              ranges: rowData.ranges.map((range, index) => ({
                id: index,
                color: range.color,
                category_name: range.category_name,
              })),
            });
          } else {
            setSelectedRow({
              ...rowData,
              ranges: rowData.ranges.map((range, index) => ({
                id: index,
                color: range.color,
                min: range.min,
                max: range.max,
              })),
            });
          }
          setDialogVisible(true);
        }}
        aria-label="Edit Legend"
      />
    );
  };

  async function fetcher() {
    setLoading(true);
    try {
      const { data } = await gisservice.Post('/getLegends', { userName });
      console.log(data);
      const kpis = await planningService.Get('/getKpis');
      setAllKPIs(kpis.data);
      setLegends(data);
      setSlectedTechnology('4G');
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  function inputValidator() {
    let error_Flag = false;
    let selectedRowCopy = {
      Technology: selectedRow.Technology,
      name: selectedRow.name,
      Label: selectedRow.Label,
      Public: typeof selectedRow.Public === 'boolean' ? selectedRow.Public : publicMap[selectedRow.Public],
      ranges: selectedRow.ranges.map((range) => ({
        color: range.color,
        min: range.min,
        max: range.max,
      })),
    };
    if (special_KPIs.includes(selectedRow.name)) {
      selectedRowCopy = {
        Technology: selectedRow.Technology,
        name: selectedRow.name,
        Label: selectedRow.Label,
        Public: typeof selectedRow.Public === 'boolean' ? selectedRow.Public : publicMap[selectedRow.Public],
        ranges: selectedRow.ranges.map((range) => ({
          color: range.color,
          category_name: range.category_name,
        })),
      };
    }

    const specialRangeSchema = Joi.object({
      color: Joi.string().disallow('000000').required(),
      category_name: Joi.string().required(),
    });
    const ranges_Schema = Joi.object({
      color: Joi.string().disallow('000000').required(),
      min: Joi.number().required(),
      max: Joi.number().required(),
    });
    const main_schema = Joi.object({
      Technology: Joi.string().required(),
      name: Joi.string().required(),
      Label: Joi.string().required(),
      Public: Joi.boolean().required(),
      ranges: Joi.array().min(1).max(50).required(),
    });

    const { error } = main_schema.validate(selectedRowCopy);

    for (let range of selectedRowCopy.ranges) {
      if (special_KPIs.includes(selectedRow.name)) {
        const { error } = specialRangeSchema.validate(range);
        if (error) {
          error_Flag = true;
          toast.error(String(error), { duration: 3000 });
        }
      } else {
        const { error } = ranges_Schema.validate(range);
        if (error) {
          error_Flag = true;
          toast.error(String(error), { duration: 3000 });
        }
      }
    }

    if (error) {
      error_Flag = true;
      toast.error(String(error), { duration: 3000 });
    }
    if (error_Flag) return true;
    return;
  }

  async function handleOk() {
    const InputError = inputValidator();
    if (InputError) {
      console.log('Input Error');
      return;
    }
    setEditMode(false);
    if (selectedRow._id) setEditMode(true);
    if (editMode) console.log('in edit mode');

    let EditTime = strftime('%Y-%m-%d-%H-%M-%S');
    let CreateTime = strftime('%Y-%m-%d-%H-%M-%S');
    let Creator = userName;
    let Modifier = userName;
    let originalLegendName = '';
    if (editMode) {
      CreateTime = selectedRow.CreateTime;
      Creator = selectedRow.Creator;
      originalLegendName = selectedRow.legendName;
      if (Creator !== Modifier) {
        toast.error('Only Legend creator has edit rights!');
        return;
      }
    }

    let vals = {
      ...selectedRow,
      isPublic: typeof selectedRow.Public === 'boolean' ? selectedRow.Public : publicMap[selectedRow.Public],
      originalLegendName,
      Creator,
      Modifier,
      CreateTime,
      EditTime,
    };
    console.log(vals);
    try {
      await gisservice.Post('/legend', vals);
    } catch (err) {
      toast.error(err);
      return;
    }
    setDialogVisible(false);
    fetcher();
    if (editMode) toast.success('Legend edited successfully.');
    else toast.success('Legend created successfully.');
    setEditMode(false);
  }
  const getSeverity = (Legend) => {
    switch (Legend.Public) {
      case 'Public':
        return 'success';
      case 'Private':
        return 'warning';
      default:
        return null;
    }
  };
  const publicBodyTemplate = (Legend) => {
    return <Tag value={Legend.Public} severity={getSeverity(Legend)}></Tag>;
  };
  const createLegend = () => {
    setIsSpecialKPI(false);
    SetCreateRelatedKPIs(
      allKPIs[selectedTechnology].filter((kpi) => !special_KPIs.includes(kpi))
    );
    setSelectedRow({
      Public: false,
      Technology: selectedTechnology,
      name: '',
      Label: '',
      ranges: [
        { id: 0, color: '000000', min: null, max: null },
        { id: 1, color: '000000', min: null, max: null },
        { id: 2, color: '000000', min: null, max: null },
      ],
    });

    setEditMode(false);
    setDialogVisible(true);
  };

  const create_LMBB_Legend = () => {
    setIsSpecialKPI(true);
    SetCreateRelatedKPIs(
      allKPIs[selectedTechnology].filter((kpi) => kpi === 'LMBB Configuration')
    );
    setSelectedRow({
      Public: false,
      Technology: selectedTechnology,
      name: 'LMBB Configuration',
      Label: '',
      ranges: LMBB_Configuration.map((LMBB, index) => ({
        id: index,
        color: '000000',
        category_name: LMBB,
      })),
    });
    setEditMode(false);
    setDialogVisible(true);
  };

  const create_Overshoot_Legend = () => {
    setIsSpecialKPI(true);
    SetCreateRelatedKPIs(
      allKPIs[selectedTechnology].filter((kpi) => kpi === 'Overshoot Flag')
    );
    setSelectedRow({
      Public: false,
      Technology: selectedTechnology,
      name: 'Overshoot Flag',
      Label: '',
      ranges: OvershootValues.map((OS, index) => ({
        id: index,
        color: '000000',
        category_name: OS,
      })),
    });

    setEditMode(false);
    setDialogVisible(true);
  };

  const create_Coverage_Legend = () => {
    setIsSpecialKPI(true);
    SetCreateRelatedKPIs(
      allKPIs[selectedTechnology].filter((kpi) => kpi === 'Coverage Flag')
    );
    setSelectedRow({
      Public: false,
      Technology: selectedTechnology,
      name: 'Coverage Flag',
      Label: '',
      ranges: CoverageValues.map((CV, index) => ({
        id: index,
        color: '000000',
        category_name: CV,
      })),
    });
    setEditMode(false);
    setDialogVisible(true);
  };

  const createItems = [
    {
      label: 'New Legend',
      items: [
        {
          label: 'Normal',
          icon: 'pi pi-angle-right',
          command: createLegend,
        },
        {
          label: 'LMBB Config',
          icon: 'pi pi-angle-right',
          command: create_LMBB_Legend,
        },
        {
          label: 'Overshoot Flag',
          icon: 'pi pi-angle-right',
          command: create_Overshoot_Legend,
        },
        {
          label: 'Coverage Flag',
          icon: 'pi pi-angle-right',
          command: create_Coverage_Legend,
        },
      ],
    },
  ];

  useEffect(() => {
    fetcher();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setRelatedKpis(
      legends
        .filter((p) => p.Technology === selectedTechnology)
        .map((legend) => ({
          ...legend,
          Public: legend.Public ? 'Public' : 'Private',
        }))
    );
    // eslint-disable-next-line
  }, [selectedTechnology, legends]);

  const dialogFooter = () => {
    return (
      <div>
        <Button onClick={handleOk}>Submit</Button>
        <Button
          severity="secondary"
          onClick={() => {
            setDialogVisible(false);
          }}
        >
          Close
        </Button>
      </div>
    );
  };

  return (
    <div className="grid grid-cols-12 gap-2">
      <div className="flex flex-row">
        <Menu model={createItems} popup ref={menuCreate} />
        <Button
          label="Create Legend"
          icon="pi pi-align-left"
          className="flex-none"
          onClick={(event) => menuCreate.current.toggle(event)}
          aria-controls="popup_menu_left"
          aria-haspopup
        />
        <Dropdown
          value={selectedTechnology}
          options={technology}
          className="flex-none ml-4"
          onChange={(e) => setSlectedTechnology(e.value)}
        />
      </div>
      <DataTable
        className="col-span-12 m-2"
        loading={loading}
        size="large"
        value={relatedKpis}
        paginator
        editMode="row"
        dataKey="id"
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
      >
        <Column field="legendName" header="Legend Name"></Column>
        <Column field={rangesTemplate} header="Ranges"></Column>
        <Column field="Technology" header="Technology"></Column>
        <Column body={publicBodyTemplate} header="Access Status"></Column>
        <Column
          header="Edit"
          field={editTemplate}
          style={{ width: '5%' }}
        ></Column>
        <Column
          header="Delete"
          field={deleteTemplate}
          style={{ width: '2%' }}
        ></Column>
      </DataTable>
      <Dialog
        style={{ width: '50vw' }}
        header={editMode ? 'Update Legend' : 'Create Legend'}
        visible={dialogVisible}
        onHide={() => setDialogVisible(false)}
        draggable={false}
        resizable={false}
        footer={dialogFooter}
      >
        <div className="grid grid-cols-8 gap-4 place-items-center">
          <span className="p-float-label mt-6 w-full md:w-20rem col-span-1">
            <Dropdown
              id="Technology"
              allowClear
              className="w-full"
              value={selectedRow.Technology}
              options={technology}
              // disabled={editMode ? true : false}
              onChange={(e) => {
                let x = Object.assign({}, selectedRow);
                x.Technology = e.value;
                setSelectedRow(x);
                SetCreateRelatedKPIs(
                  allKPIs[e.value].map((kpi) => ({ label: kpi, value: kpi }))
                );
              }}
              display="chip"
            />
            <label htmlFor="Technology">Technology</label>
          </span>
          <span className="p-float-label mt-6 w-full md:w-20rem col-span-3">
            <Dropdown
              id="KPI"
              showSearch
              allowClear
              className="w-full"
              value={selectedRow.name}
              options={
                editMode ? relatedKpis.map((p) => p.name) : CreateRelatedKPIs
              }
              disabled={editMode || isSpecialKPI ? true : false}
              onChange={(e) => {
                let x = Object.assign({}, selectedRow);
                x.name = e.value;
                setSelectedRow(x);
              }}
              filter
              display="chip"
            />
            <label htmlFor="KPI">KPI</label>
          </span>
          <span className="p-float-label mt-6 w-full md:w-20rem col-span-2">
            <InputText
              id="Label"
              className="w-full"
              value={selectedRow.Label}
              onChange={(e) => {
                let x = Object.assign({}, selectedRow);
                x.Label = e.target.value;
                setSelectedRow(x);
              }}
            />
            <label htmlFor="Label">Label</label>
          </span>
          <span className="p-float-label mt-6 w-full md:w-20rem col-end-8">
            <ToggleButton
              onLabel="Public"
              offLabel="Private"
              id="public"
              className="w-full"
              checked={typeof selectedRow.Public === 'boolean' ? selectedRow.Public : publicMap[selectedRow.Public]}
              onChange={(e) => {
                let x = Object.assign({}, selectedRow);
                x.Public = e.value;
                setSelectedRow(x);
              }}
            />
          </span>
          {special_KPIs.includes(selectedRow.name)
            ? selectedRow &&
            selectedRow.ranges &&
            selectedRow.ranges.map((range, index) => (
              <>
                <span className="p-float-label mt-6 w-full md:w-20rem col-start-1">
                  <ColorPicker
                    value={range.color}
                    onChange={(e) => {
                      const cp = { ...selectedRow };
                      cp.ranges[index].color = `#${e.value}`;
                      setSelectedRow(cp);
                    }}
                  ></ColorPicker>
                </span>
                <span className="p-float-label mt-6 w-full md:w-20rem col-span-1">
                  {range.color}
                </span>
                <span className="p-float-label mt-6 w-full md:w-20rem col-span-2">
                  <InputText
                    id="CATEGORY"
                    className="w-full"
                    value={range.category_name}
                    disabled={true}
                  />
                  <label htmlFor="CATEGORY">Category</label>
                </span>
              </>
            ))
            : selectedRow &&
            selectedRow.ranges &&
            selectedRow.ranges.map((range, index) => (
              <>
                <span className="p-float-label mt-6 w-full md:w-20rem col-start-1">
                  <ColorPicker
                    value={range.color}
                    onChange={(e) => {
                      const cp = { ...selectedRow };
                      cp.ranges[index].color = `#${e.value}`;
                      setSelectedRow(cp);
                    }}
                  ></ColorPicker>
                </span>
                <span className="p-float-label mt-6 w-full md:w-20rem col-span-1">
                  {range.color}
                </span>
                <span className="p-float-label mt-6 w-full md:w-20rem col-span-2">
                  <InputNumber
                    className="w-full"
                    value={range.min}
                    mode="decimal"
                    minFractionDigits={2}
                    id="MIN"
                    onChange={(e) => {
                      // setSelectedRow({
                      //   ...selectedRow,
                      //   ranges: selectedRow.ranges.map((range, innerIndex) => {
                      //     return range.id === index ? {...selectedRow.ranges[index], min: range.id} : {...selectedRow.ranges[index]}
                      //     // return { ...selectedRow.ranges[index], min: range.id === index ? e.value : range.min }
                      //     // if (range.id === index) return { ...selectedRow.ranges[index], min: e.value }
                      //     // else return { ...selectedRow.ranges[index] };
                      //   })
                      // })
                      const cp = { ...selectedRow };
                      cp.ranges[index].min = e.value;
                      setSelectedRow(cp);
                    }}
                  />
                  <label htmlFor="MIN">Min</label>
                </span>
                <span className="p-float-label mt-6 w-full md:w-20rem col-span-2">
                  <InputNumber
                    id="MAX"
                    className="w-full"
                    mode="decimal"
                    minFractionDigits={2}
                    value={range.max}
                    onChange={(e) => {
                      const cp = { ...selectedRow };
                      cp.ranges[index].max = e.value;
                      setSelectedRow(cp);
                    }}
                  />
                  <label htmlFor="MAX">Max</label>
                </span>
                <div className="mt-6 w-full md:w-20rem col-span-2">
                  <Button
                    icon="pi pi-sort-up"
                    onClick={(e) => {
                      let x = Object.assign({}, selectedRow);
                      x.ranges = x.ranges.map((range, innerIndex) => {
                        return {
                          ...range,
                          id: index <= innerIndex ? range.id + 1 : range.id,
                        };
                      });
                      x.ranges.splice(index, 0, {
                        id: index,
                        color: '000000',
                        min: null,
                        max: null,
                      });
                      setSelectedRow(x);
                    }}
                    rounded
                    text
                    aria-label="Filter"
                  />
                  <Button
                    icon="pi pi-sort-down"
                    onClick={(e) => {
                      let x = Object.assign({}, selectedRow);
                      x.ranges = x.ranges.map((range, innerIndex) => {
                        return {
                          ...range,
                          id: index < innerIndex ? range.id + 1 : range.id,
                        };
                      });
                      x.ranges.splice(index + 1, 0, {
                        id: index + 1,
                        color: '000000',
                        min: null,
                        max: null,
                      });
                      setSelectedRow(x);
                    }}
                    rounded
                    text
                    aria-label="Filter"
                  />
                  <Button
                    icon="pi pi-times"
                    onClick={(e) => {
                      let x = Object.assign({}, selectedRow);
                      x.ranges = x.ranges.filter((p) => p.id !== index);
                      x.ranges = x.ranges.map((range, innerIndex) => {
                        return {
                          ...range,
                          id: index <= innerIndex ? range.id - 1 : range.id,
                        };
                      });
                      setSelectedRow(x);
                    }}
                    rounded
                    text
                    severity="danger"
                    aria-label="Cancel"
                  />
                </div>
              </>
            ))}
        </div>
      </Dialog>
      <Dialog
        style={{ width: '20vw' }}
        header={() => {
          return (
            <>
              <i
                className="pi pi-exclamation-circle"
                style={{ fontSize: '1.3rem', color: 'red' }}
              />
              <span> Delete Legend</span>
            </>
          );
        }}
        visible={deleteVisible}
        onHide={() => setDeleteVisible(false)}
        draggable={false}
        resizable={false}
        footer={() => {
          return (
            <div>
              <Button onClick={handleDelete}>Delete</Button>
              <Button
                severity="secondary"
                onClick={() => {
                  setDeleteVisible(false);
                }}
              >
                Cancel
              </Button>
            </div>
          );
        }}
      >
        <p>Do you want to delete {selectedRow.legendName}?</p>
      </Dialog>
      ;
    </div>
  );
};

export default Legends;
